import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentAddFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 11c0 .552-.447 1-.999 1H4.167L2 14V3.996A.997.997 0 0 1 3 3h10a1 1 0 0 1 1 1v7ZM7.5 5v2h-2v1h2v2h1V8h2V7h-2V5h-1Z"
    />
  </svg>
);
export default IconCommentAddFilledSizeS;
